import React from 'react';
import _ from 'lodash';

import {
  modalUtil,
  Table
} from 'iron-forge-react-modules';
import {
  BaseWidget,
  PermissionWall,
  permissionUtil
} from 'modules';

import { Button } from '@mui/material';
import { Check } from '@mui/icons-material';
import * as AssignRoleModal from './AssignRoleModal/AssignRoleModal';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>({});



export interface IProps {
  siteUserId: string;
}

export const FC: React.FC<IProps> = ({ siteUserId }) => {
  const queryTuple = dataService.useQuery(siteUserId);
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['assignRole']);
  const [evaluatePermission] = permissionUtil.usePermissions({});
  const [unassignRole] = dataService.useUnassignRole(siteUserId);



  const handleClickRowPopoverOption = React.useCallback(
    (rowId: string, optionId: string) => {
      if (optionId === 'unassignRole' && window.confirm("Are you sure you want to unassign this role?")) {
        unassignRole(rowId);
      }
    },
    [unassignRole]
  );

  const rows = React.useMemo(
    () => _.map(queryTuple.data.assignedRoles, (role): types.IRow => ({
      id: role.id,
      popoverOptions: [
        {
          id: 'unassignRole',
          show: evaluatePermission(['permission_assignRole']),
          label: "Unassign Role"
        }
      ],
      columnId2Value: {
        isGlobal: {
          type: 'component',
          sortableValue: '',
          label: role.isGlobal ? <Check color="success" /> : <div />
        },
        roleName: {
          type: 'string',
          label: role.roleName
        },
        storeName: {
          type: 'string',
          label: role.storeName ?? 'N/A'
        }
      }
    })),
    [evaluatePermission, queryTuple.data.assignedRoles]
  );

  return (
    <>
      <BaseWidget.FC
        title="Assigned Roles"
        elAction={(
          <PermissionWall.FC requiresPermissions={['permission_assignRole']}>
            <Button onClick={() => setModalIsOpen('assignRole', true)}>
              Add Role
            </Button>
          </PermissionWall.FC>
        )}>
        <TableComponent
          rows={rows}
          onClickRowPopoverOption={handleClickRowPopoverOption}
          columns={[
            {
              id: 'roleName',
              label: "Role Name"
            },
            {
              id: 'storeName',
              label: "Store Name"
            },
            {
              id: 'isGlobal',
              label: "Is Global"
            }
          ]} />
      </BaseWidget.FC>

      {modalType2IsOpen.assignRole && (
        <AssignRoleModal.FC
          siteUserId={siteUserId}
          onClose={() => setModalIsOpen('assignRole', false)} />
      )}
    </>
  );
};
